/* istanbul ignore file */

import { sendGAEvent } from '@noths/polaris-client-google-analytics';
var EVENT_CATEGORY = 'Navigation - mobile menu';
export var setNavOpen = function setNavOpen(open) {
  return sendGAEvent({
    event: 'custom_event',
    event_action: open ? 'Open' : 'Close',
    event_category: EVENT_CATEGORY,
    event_label: 'not set'
  });
};